export const dateSorter = (a, b) => (key: string) => {
    if (!b[key] || !a[key]) return 0;

    return new Date(b[key]).getTime() - new Date(a[key]).getTime();
};

export const stringSorter = (a: any, b: any) => (key: string) => {
    if (!b[key] || !a[key]) return 0;

    return a[key].localeCompare(b[key]);
};

export const numberSorter = (a: any, b: any) => (key: string) =>
    (a?.[key] ?? 0) - (b?.[key] ?? 0);
